import { render } from "./CustomizerFallback.vue?vue&type=template&id=56091db0&scoped=true"
import script from "./CustomizerFallback.vue?vue&type=script&lang=js"
export * from "./CustomizerFallback.vue?vue&type=script&lang=js"

import "./CustomizerFallback.vue?vue&type=style&index=0&id=56091db0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56091db0"]])

export default __exports__